import { AuthError } from '@auth/auth.enum';
import { UserInfo } from '@shared/models/auth.model';

export class InitAuthentication {
  static readonly type = '[Auth] Init Authentication';

  constructor() {}
}

export class UpdateUserOnAuthTokenChange {
  static readonly type = '[Auth] Login';
  constructor(readonly userInfo: UserInfo) {}
}

export class RemoveUserOnAuthTokenChange {
  static readonly type = '[Auth] Logout';
}

export class SaveTokenOnAuthTokenChange {
  static readonly type = '[Auth] Update Token';

  constructor(readonly authToken: string) {}
}

export class SaveClaimsOnAuthTokenChange {
  static readonly type = '[Auth] Change Claims';

  constructor(readonly authClaims: any) {}
}

export class MonitorLoginExpiration {
  static readonly type = '[Auth] Monitor Login Expiration';

  constructor(readonly userUid: string) {}
}

export class MonitorMFAReset {
  static readonly type = '[Auth] Monitor MFA Reset';

  constructor(readonly userUid: string) {}
}

export class SignUpAuthenticated {
  static readonly type = '[Auth] Sign Up Authenticated';

  constructor() {}
}

export class SignOutWithRedirect {
  static readonly type = '[Auth] Sign Out With Redirect';

  constructor(
    public signIn?: boolean | null,
    trace?: string,
  ) {
    if (trace) {
      console.log('SignOutWithRedirect:', trace);
    }
  }
}

export class SignOutWithoutRedirect {
  static readonly type = '[Auth] Sign Out Without Redirect';
}

export class CancelAuthSignup {
  static readonly type = '[Auth] Cancel Auth Signup';
}

export class CancelEmailSignup {
  static readonly type = '[Auth] Cancel Email Signup';
}

export class ChangePassword {
  static readonly type = '[Auth] Change Password';
  constructor(readonly email: string) {}
}

export class SendPasswordResetEmail {
  static readonly type = '[Auth] Send Password Reset Email';
  constructor(readonly email: string) {}
}

export class SendVerificationEmail {
  static readonly type = '[Auth] Send Verification Email';
  constructor(
    readonly redirect?: string,
    readonly lang?: string,
  ) {}
}

export class GetInvite {
  static readonly type = '[Auth] Get Invite';
  constructor(readonly inviteKey?: string) {}
}

export class ResetUserInfo {
  static readonly type = '[Auth] Reset User Info';
}

export class GoToSignIn {
  static readonly type = '[Auth] Go to SignIn';
  constructor(
    readonly redirect?: string,
    readonly mode?: string,
    readonly activate?: string,
    readonly lang?: string,
  ) {}
}

export class GoToSignUp {
  static readonly type = '[Auth] Go to SignUp';
  constructor(
    readonly redirect?: string,
    readonly activate?: string,
  ) {}
}

export class GoToLogoutUrl {
  static readonly type = '[Auth] Go to Logout Url';
  constructor(readonly logoutUrl: string) {}
}

export class AccessDenied {
  static readonly type = '[Auth] Access Denied';

  constructor(readonly message?: string) {}
}

export class LinkPassword {
  static readonly type = '[Auth] Link Password';
  constructor(
    readonly newPassword: string,
    readonly oldPassword?: string,
  ) {}
}

export class UnlinkPassword {
  static readonly type = '[Auth] Unlink Password';
}

export class PasswordUpdated {
  static readonly type = '[Auth] Password Updated';
}

export class LinkProvider {
  static readonly type = '[Auth] Link Provider';
  constructor(readonly provider: string) {}
}

export class UnlinkProvider {
  static readonly type = '[Auth] Unlink Provider';
  constructor(readonly provider: string) {}
}

export class AuthenticationError {
  static readonly type = '[Auth] Error';

  constructor(readonly code?: AuthError) {}
}

export class GenerateTOTPSecret {
  static readonly type = '[Auth] Generate TOTP Secret';
  constructor(readonly appName: string = 'Zeffi') {}
}

export class VerifyTOTPCode {
  static readonly type = '[Auth] Verify TOTP Code';

  constructor(readonly code: string) {}
}

export class VerifyPhoneCode {
  static readonly type = '[Auth] Verify Phone Code';

  constructor(readonly code: string) {}
}

export class GenerateSMSSecret {
  static readonly type = '[Auth] Generate SMS Secret';

  constructor(
    readonly phoneNumber: string,
    readonly resolver?: any,
  ) {}
}

export class VerifySMSCode {
  static readonly type = '[Auth] Verify SMS Code';

  constructor(readonly code: string) {}
}

export class DisableMemberMfa {
  static readonly type = '[Auth] Disable Member Mfa';
  constructor(
    readonly uid: string,
    readonly reload: boolean = false,
  ) {}
}

export class DisableSMSMfa {
  static readonly type = '[Auth] Disable SMS Mfa';
}

export class DisableTeamSmsMfa {
  static readonly type = '[Auth] Disable Team Sms Mfa';
}

export class SetDefatultMfaFactor {
  static readonly type = '[Auth] Set Default Mfa Factor';
  constructor(readonly mfaFactor: 'totp' | 'phone') {}
}
